import { createTheme, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import "../src/styles/globals.css";
import Layout from "./layouts/Layout";
import Landing from "./pages/landing";
import MashListList from "./pages/mashlist/list/list";
import Wizard from "./pages/mashlist/wizard/wizard";
import MashListRouter from "./pages/mashlist/[id]/mashlist-router";
import VotingSession from "./pages/mashlist/[id]/voting-session/voting-session";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Login from "./pages/login/login";
import Register from "./pages/register/register";
import ForgotPassword from "./pages/auth/forgot-password";
import ResetPassword from "./pages/auth/reset-password";
import ConfirmEmail from "./pages/auth/confirm-email";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f6f6f6", // #FFF200
    },
    secondary: {
      main: "#FF3900", // #FF3900
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#f9f9f9",
        },
      },
    },
  },
});

export default function App() {
  return (
    <>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/mashlist/list" element={
                <ProtectedRoute>
                  <MashListList />
                </ProtectedRoute>
              } />
              <Route path="/mashlist/wizard" element={
                <ProtectedRoute>
                  <Wizard />
                </ProtectedRoute>
              } />
              <Route path="/mashlist/:id/manage" element={
                <ProtectedRoute>
                  <MashListRouter mode="manage" />
                </ProtectedRoute>
              } />
              <Route path="/mashlist/:id/voting-session" element={<VotingSession />} />
              <Route path="/mashlist/:shortkey" element={<MashListRouter />} />
              <Route path="*" element={<h1>404 NOT FOUND</h1>} />
            </Routes>
          </Layout>
        </ThemeProvider>
      </AuthProvider>
    </>
  );
}
